module.exports = __webpack_public_path__ + "static/media/spaceinvader.8b6ac562.png";